import accountService from "../../services/account";
import bookingService from "../../services/booking";
import store from "./../../store";
import moment from "moment";
import countryService from "../../services/country";
import mixin from "../../mixins/mixin";
import Vue from "vue";
import { StripeElementCard } from "@vue-stripe/vue-stripe";

export default {
  store,
  data() {
    return {
      rental: {
        currency: { symbol: "€" },
        user_web: { first_payment: false },
      },
      countries: [],
      duration: "",
      pricePerNight: "",
      bookingDetail: {
        nbr_adults: "",
        nbr_children: "",
        price: "",
        checking: "",
        checkout: "",
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        city_taxes: 0,
        address: "",
        city: "",
        country: "",
        zip_code: "",
        comments: "",
        card_token: "",
      },
      checking: "",
      checkout: "",
      isLoading: false,
      isCreatedBooking: false,
      showSecureIframe: false,
      paymentIntent: [],
      stripe: null,
      loading: true,
      lang: this.$route.query.lang || "fr",
      promoCode: "",
      promoCodeApplying: false,
      promoCodeApplied: false,
      promoCodeError: false,
      promoData: {},
      totalWithPromo: null,
      priceWithPromo: null,
      initialPrice: null,
      cguAccepted: false,
    };
  },

  mixins: [mixin],

  components: {
    VLoading: require("components/loading/loading.vue"),
    VCgvModal: require("./CgvModal"),
    StripeElementCard,
  },

  async mounted() {
    moment.locale("fr");
    Vue.config.lang = this.lang;
    this.loading = false;
    const params = this.$route.params;
    const query = this.$route.query;

    const propertyKey = params.propertyKey;
    this.bookingDetail.checking = query.checkin;
    this.bookingDetail.checkout = query.checkout;
    this.checking = moment(query.checkin, "YYYY-MM-DD")
      .locale(this.lang)
      .format("ll");
    this.checkout = moment(query.checkout, "YYYY-MM-DD")
      .locale(this.lang)
      .format("ll");
    this.bookingDetail.nbr_adults = Number(query.adultsCount);
    this.bookingDetail.nbr_children = Number(query.childrenCount);

    await countryService.get(this);
    await accountService.getRentalInfo(this, propertyKey);
    const data = {
      start_date: moment(this.bookingDetail.checking, "YYYY-MM-DD").format(
        "Y-MM-DD"
      ),
      end_date: moment(this.bookingDetail.checkout, "YYYY-MM-DD").format(
        "Y-MM-DD"
      ),
      id: this.rental.id,
      nbr_adults: this.bookingDetail.nbr_adults,
      nbr_children: this.bookingDetail.nbr_children,
      lang: this.lang,
    };
    const details = await bookingService.checkBookingAvailability(
      this,
      data,
      true
    );
    this.bookingDetail.price = details.rental.price;
    this.bookingDetail.city_taxes = details.rental.city_taxes;
    this.duration = details.rental.duration;
    this.pricePerNight = parseFloat(
      this.bookingDetail.price / this.duration
    ).toFixed(2);

    if (this.rental.user_web && this.rental.user_web[`cgv_${this.lang}`]) {
      this.rental.user_web.cgv = this.rental.user_web[
        `cgv_${this.lang}`
      ].replace("<p>​</p>", "");
    };

    const cgvFr = "<p>1 - Objet</p><p>Les présentes Conditions Générales de Vente (CGV) régissent toutes les réservations effectuées sur notre site de location courte durée. En réservant un logement sur notre site, vous acceptez sans réserve les présentes CGV.</p><p>2 - Réservation et Paiement</p><p>La réservation devient effective dès la réservation.</p><p>3 - Annulation</p><p>Toute annulation doit être notifiée par écrit. </p><p>4 - Arrivée et Départ</p><p>Le logement est disponible à partir de 15h le jour de l’arrivée et doit être libéré avant 11h le jour du départ. </p><p>5 - Utilisation des Lieux</p><p>Le locataire s’engage à utiliser les lieux de manière paisible et à respecter le voisinage. Toute nuisance causée au voisinage pourrait entraîner la résiliation immédiate de la location sans remboursement.</p><p>6 - Dépôt de Garantie</p><p>Un dépôt de garantie sera effectué avant l’arrivée. Ce dépôt sera restitué dans un délai de 7 jours après le départ, sous réserve qu’aucun dommage ne soit constaté.</p><p>7 - Responsabilité</p><p>Nous déclinons toute responsabilité en cas de vol, perte ou dommage des biens personnels du locataire. Le locataire est responsable de tout dommage causé par lui-même ou ses accompagnants pendant la période de location.</p><p>8 - Litiges</p><p>Tout litige relatif à l’exécution ou à l’interprétation des présentes CGV sera soumis au tribunal compétent du lieu du bien loué.</p>";
    const cgvEn = "<p>1 - Purpose</p><p>These General Conditions of Sale (CGV) govern all reservations made on our short-term rental site. By reserving accommodation on our site, you accept these General Terms and Conditions without reservation.</p><p>2 - Reservation and Payment</p><p>The reservation becomes effective upon reservation.</p><p> 3 - Cancellation</p><p>Any cancellation must be notified in writing. </p><p>4 - Arrival and Departure</p><p>Accommodation is available from 3 p.m. on the day of arrival and must be vacated before 11 a.m. on the day of departure. </p><p>5 - Use of the Premises</p><p>The tenant undertakes to use the premises peacefully and to respect the neighborhood. Any nuisance caused to the neighborhood could result in the immediate termination of the rental without refund.</p><p>6 - Security Deposit</p><p>A security deposit will be made before arrival. This deposit will be returned within 7 days after departure, provided that no damage is noted.</p><p>7 - Liability</p><p>We decline all responsibility in the event of theft, loss or damage to the tenant's personal property. The tenant is responsible for any damage caused by himself or his companions during the rental period.</p><p>8 - Disputes</p><p>Any dispute relating to execution or interpretation of these General Terms and Conditions will be submitted to the competent court of the location of the rented property.</p>";
    const cgvIt = "<p>1 - Scopo</p><p>Le presenti Condizioni Generali di Vendita (CGV) regolano tutte le prenotazioni effettuate sul nostro sito di noleggio a breve termine. Prenotando un alloggio sul nostro sito, accetti i presenti Termini e condizioni generali senza riserve.</p><p>2 - Prenotazione e pagamento</p><p>La prenotazione diventa effettiva al momento della prenotazione.</p><p> 3 - Cancellazione</p><p>Qualsiasi cancellazione deve essere comunicata per iscritto. </p><p>4 - Arrivo e partenza</p><p>L'alloggio è disponibile a partire dalle ore 15:00 del giorno di arrivo e deve essere lasciato libero entro le ore 11:00 del giorno di partenza. </p><p>5 - Utilizzo dei locali</p><p>L'affittuario si impegna a utilizzare i locali in modo pacifico e a rispettare il vicinato. Qualsiasi disturbo causato al vicinato potrebbe comportare la risoluzione immediata del noleggio senza rimborso.</p><p>6 - Deposito cauzionale</p><p>Un deposito cauzionale verrà versato prima dell'arrivo. Questo deposito verrà restituito entro 7 giorni dalla partenza, a condizione che non vengano rilevati danni.</p><p>7 - Responsabilità</p><p>Decliniamo ogni responsabilità in caso di furto, smarrimento o danneggiamento del beni personali dell'affittuario. L'affittuario è responsabile di ogni danno causato da lui stesso o dai suoi accompagnatori durante il periodo di locazione.</p><p>8 - Controversie</p><p>Ogni controversia relativa all'esecuzione o</p>";
    const cgvPt = "<p>1 - Finalidade</p><p>As presentes Condições Gerais de Venda (CGV) regem todas as reservas efetuadas no nosso site de aluguer de curta duração. Ao reservar alojamento no nosso site, você aceita estes Termos e Condições Gerais sem reservas.</p><p>2 - Reserva e Pagamento</p><p>A reserva entra em vigor no momento da reserva.</p><p> 3 - Cancelamento</p><p>Qualquer cancelamento deverá ser notificado por escrito. </p><p>4 - Chegada e Saída</p><p>A acomodação está disponível a partir das 15h do dia de chegada e deverá ser desocupada antes das 11h do dia de saída. </p><p>5 - Utilização das Instalações</p><p>O inquilino compromete-se a utilizar as instalações de forma pacífica e a respeitar a vizinhança. Qualquer incômodo causado à vizinhança poderá resultar na rescisão imediata do aluguel sem reembolso.</p><p>6 - Depósito de Segurança</p><p>Um depósito de segurança será feito antes da chegada. Esta caução será devolvida no prazo de 7 dias após a partida, desde que nenhum dano seja constatado.</p><p>7 - Responsabilidade</p><p>Declinamos qualquer responsabilidade em caso de roubo, perda ou dano ao bens pessoais do inquilino. O inquilino é responsável por quaisquer danos causados ​​por si ou pelos seus acompanhantes durante o período de aluguer.</p><p>8 - Litígios</p><p>Qualquer litígio relativo à execução ou interpretação destes Termos e Condições Gerais será submetido ao tribunal competente do local do imóvel alugado.</p>";
    const cgvEs = "<p>1 - Objeto</p><p>Las presentes Condiciones Generales de Venta (CGV) rigen todas las reservas realizadas en nuestro sitio de alquiler a corto plazo. Al reservar alojamiento en nuestro sitio, acepta estos Términos y Condiciones Generales sin reservas.</p><p>2 - Reserva y Pago</p><p>La reserva se hace efectiva al realizar la reserva.</p><p> 3 - Cancelación</p><p>Cualquier cancelación deberá ser notificada por escrito. </p><p>4 - Llegada y Salida</p><p>El alojamiento está disponible a partir de las 15 horas del día de llegada y deberá quedar libre antes de las 11 horas del día de salida. </p><p>5 - Uso del Local</p><p>El inquilino se compromete a utilizar el local de forma pacífica y respetando el vecindario. Cualquier molestia causada al vecindario podría resultar en la terminación inmediata del alquiler sin reembolso.</p><p>6 - Depósito de Seguridad</p><p>Se realizará un depósito de seguridad antes de la llegada. Este depósito será devuelto dentro de los 7 días posteriores a la salida, siempre que no se observen desperfectos.</p><p>7 - Responsabilidad</p><p>Declinamos toda responsabilidad en caso de robo, pérdida o daño del propiedad personal del inquilino. El inquilino es responsable de cualquier daño causado por él o sus acompañantes durante el período de alquiler.</p><p>8 - Controversias</p><p>Cualquier disputa relacionada con la ejecución o interpretación de estos Términos y Condiciones Generales será presentado al tribunal competente de la ubicación del inmueble alquilado.</p>";

    if ((!this.rental.user_web.cgv || this.rental.user_web.cgv.length <= 5) && this.lang === 'fr') {
      this.rental.user_web.cgv = cgvFr;
    }
    if ((!this.rental.user_web.cgv || this.rental.user_web.cgv.length <= 5) && this.lang === 'en') {
      this.rental.user_web.cgv = cgvEn;
    }
    if ((!this.rental.user_web.cgv || this.rental.user_web.cgv.length <= 5) && this.lang === 'it') {
      this.rental.user_web.cgv = cgvIt;
    }
    if ((!this.rental.user_web.cgv || this.rental.user_web.cgv.length <= 5) && this.lang === 'pt') {
      this.rental.user_web.cgv = cgvPt;
    }
    if ((!this.rental.user_web.cgv || this.rental.user_web.cgv.length <= 5) && this.lang === 'es') {
      this.rental.user_web.cgv = cgvEs;
    }

    await accountService.getConnectedStripePublicKey(
      this,
      this.rental.user_web_key,
      propertyKey
    );

    this.handle3DCListener();
  },

  watch: {
    isCreatedBooking(val) {
      if (val) {
        this.loading = false;
        const params = {
          propertyKey: this.rental.property_key,
          checkin: this.bookingDetail.checking,
          checkout: this.bookingDetail.checkout,
          adultsCount: this.bookingDetail.nbr_adults,
          childrenCount: this.bookingDetail.nbr_children,
          duration: this.duration,
          price: this.bookingDetail.price,
          tax: this.bookingDetail.city_taxes,
          lang: this.lang,
        };
        const queryData = {
          initialPrice:
            this.initialPrice != null
              ? this.initialPrice
              : this.bookingDetail.price,
        };
        if (Object.keys(this.promoData).length !== 0) {
          queryData.promoType = this.promoData.type;
          queryData.amount =
            this.promoData.type === "fixed"
              ? this.promoData.amount
              : this.promoData.percent;
        }

        Vue.router.push({
          name: "booking.confirmation",
          params: {
            ...params,
          },
          query: queryData,
        });
      }
    },
  },

  methods: {
    generateStripeCardToken() {
      this.isLoading = true;
      this.$refs.elementRef.submit();
    },

    createBooking(token) {
      this.isLoading = true;

      this.bookingDetail.card_token = token.id;
      this.bookingDetail.web_key = this.rental.user_web_key;
      this.bookingDetail.property_key = this.rental.property_key;
      this.bookingDetail.status = 2;
      this.bookingDetail.cleaning = this.rental.cleaning;
      this.bookingDetail.checking = moment(this.bookingDetail.checking).format(
        "Y-MM-DD"
      );
      this.bookingDetail.checkout = moment(this.bookingDetail.checkout).format(
        "Y-MM-DD"
      );
      this.bookingDetail.is_required_card_detail = true;
      this.bookingDetail.created_from_engine = true;
      this.bookingDetail.lang = this.lang;
      if (
        Object.keys(this.promoData).length !== 0 &&
        this.priceWithPromo !== null
      ) {
        this.bookingDetail.promo_type = this.promoData.type;
        this.bookingDetail.promo_amount =
          this.promoData.type === "fixed"
            ? this.promoData.amount
            : this.promoData.percent;
        this.bookingDetail.promo_id = this.promoData.id;
      }
      if (this.bookingDetail.booking_id)
        bookingService.retryWebsiteReservationPayment(this, this.bookingDetail);
      else bookingService.createBooking(this, this.bookingDetail);
    },

    on3DSComplete() {
      $("#secure-iframe").css("display", "none");
      const vm = this;
      vm.loading = true;
      if (vm.stripe && vm.paymentIntent && vm.paymentIntent.client_secret) {
        vm.stripe
          .retrievePaymentIntent(vm.paymentIntent.client_secret)
          .then((result) => {
            if (
              (result.paymentIntent &&
                result.paymentIntent.last_payment_error &&
                result.paymentIntent.last_payment_error.code &&
                result.paymentIntent.last_payment_error.code ===
                  "payment_intent_authentication_failure") ||
              result.paymentIntent.status === "requires_payment_method"
            ) {
              vm.loading = false;
              vm.showSecureIframe = false;
              toastr.error(this.$t("payments.error.3ds_authentication_failed"));
            } else if (
              result.paymentIntent.status === "succeeded" ||
              result.paymentIntent.status === "requires_capture"
            ) {
              vm.showSecureIframe = false;
              vm.loading = true;
              vm.bookingDetail.confirmed_intent = result.paymentIntent;
              bookingService.confirmBookingPayment(vm, vm.bookingDetail);
            }
          });
      }
    },

    handle3DCListener() {
      const ifr = document.querySelector("iframe");
      const otherWindow = ifr.contentWindow;
      ifr.addEventListener(
        "load",
        () => {
          const ifrElementId = ifr.getAttribute("id");
          if (
            ifrElementId === "booking-engine" ||
            ifrElementId === "secure-iframe"
          ) {
            otherWindow.postMessage("3DS-authentication-complete", "*");
            otherWindow.addEventListener(
              "message",
              (ev) => {
                if (ev.data === "3DS-authentication-complete") {
                  this.on3DSComplete();
                }
              },
              false
            );
          }
        },
        false
      );
    },

    applyPromoCode() {
      if (this.promoCodeApplying) {
        return;
      }

      this.promoCodeApplying = true;

      if (this.promoCode === "") {
        this.promoCodeError = false;
        this.promoData = {};
        this.initialPrice = null;
        this.totalWithPromo = null;
        this.priceWithPromo = null;
        this.pricePerNight = parseFloat(
          this.bookingDetail.price / this.duration
        ).toFixed(2);
        return;
      }

      const data = {
        rentalId: this.rental.id,
        promoCode: this.promoCode,
      };

      accountService.applyPromoCode(this, data);
    },

    acceptCGU() {
      this.cguAccepted = !this.cguAccepted;
    },

    openCgvModal() {
      this.openModal("#cgv-modal");
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/external-availability/checkOut.js